import { isEqual } from "lodash";
import { memo } from "react";
import HomeSection from "../widget/HomeSection/HomeSection";
import Title from "../widget/Title/Title";
import { preStaticUrl } from "../../../../constants/env_config";
import "./News.scss";
import SvgComponent from "../../../../components/SvgComponent/SvgComponent";
import { useCustomTranslation } from "../../../../hooks/useCustomTranslation";
const _preStaticUrl = preStaticUrl + "/img/zypher/news/";

const newsList: INavItem[] = [
  {
    imgPath: "/news/1.webp",
    title:
      "Zypher Network\'s $7M Bet on Decentralized Trust for AI Agents",
    timestamp: "Jul 04, 2025",
    link: "https://zyphergames.substack.com/p/zypher-networks-7m-bet-on-decentralized",
  },
  {
    imgPath: "/news/3.webp",
    title: 'Zypher zkAI Mining Protocol Launches on BNB Chain with Exclusive Airdrop Rewards!💎',
    timestamp: "Jun 19, 2025",
    link: "https://zyphergames.substack.com/p/zypher-zkai-mining-protocol-launches",
  },
  {
    imgPath: "/news/2.webp",
    title: "Zypher Network: zkPrompt System Design",
    timestamp: "APR 28, 2025",
    link: "https://zyphergames.substack.com/p/zypher-network-zkprompt-system-design",
  },
];
const News = memo(() => {
  const { t } = useCustomTranslation();
  return (
    <HomeSection classNames="news animate">
      <Title title={t("In the News")} />
      <div className="news_nav">
        <a
          href="https://zyphergames.substack.com"
          target="_blank"
          rel="noreferrer"
          className="all_media"
        >
          {t("All Media")}
          {/* <SvgComponent src={preStaticUrl + "/img/icon/arrow-right.svg"} /> */}
        </a>
        <ul>
          {newsList.map((v) => (
            <NavItem item={v} key={v.title} />
          ))}
        </ul>
      </div>
    </HomeSection>
  );
}, isEqual);

type INavItem = {
  imgPath: string;
  title: string;
  timestamp: string;
  link: string;
};
type INavItemProps = {
  item: INavItem;
};
const NavItem = memo(({ item }: INavItemProps) => {
  const { t } = useCustomTranslation();
  return (
    <li>
      <a href={item.link} target="_blank" rel="noreferrer">
        <img className="news_nav_img" src={item.imgPath} alt={item.title} />
        <p className="news_nav_title">{t(item.title)}</p>
        <p className="news_nav_time">{t(item.timestamp)}</p>
      </a>
    </li>
  );
}, isEqual);

export default News;
